import isEmpty from 'lodash/isEmpty'
import React, { useContext as useContextCore, useMemo } from 'react'
import { queries } from '../graphql'
import { useList, useUser } from '@ztechapps/common.hook'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const { user } = useUser()
  const filter = { users: { $elemMatch: { $eq: user?._id } } }
  const { list, ...listResult } = useList({ ...queries.allConfig, limit: 0, filter, sort: { createdAt: -1 } })

  const hasBoards = useMemo(() => !isEmpty(list), [list])

  return <CoreProvider value={{ ...props, hasBoards, list, ...listResult }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
